/* ══════════════════════════════════════════════════════════════════
   搜索浮层。**EB.overlay 的调用方**，不自己写浮层。

   滚动锁、焦点陷阱、遮罩、Esc 关闭、同一时间只允许一个浮层 —— 全在 EB.overlay 里，
   这里只登记一个 id，然后管三件自己的事：取结果、换主体、走键盘。

   **不在这里拼任何卡片。** 结果 HTML 由 Shopify 渲染好返回
   （/search/suggest?q=…&section_id=…），这边只把主体整块换掉。
   要是改成 JSON 接口，产品卡就得在 JS 里再画一遍 —— 那张卡全站只有一份，
   多出来的那份迟早跟 Liquid 那份长不一样。

   输入行**不在被替换的范围里**，所以打字过程中光标不会跳、输入法不会断。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var OVERLAY_ID = 'search';
  var RECENT_KEY = 'eb:recent-searches';
  var RECENT_MAX = 5;
  var DEBOUNCE = 220;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var panel = null;
  var input = null;
  var releaseFocus = null;
  var controller = null;
  var lastQuery = null;
  var cursor = -1;

  function el(sel, ctx) { return (ctx || document).querySelector(sel); }
  function all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function strings() { return (window.EBStrings && window.EBStrings.search) || {}; }

  /* ── 最近搜过：只在这台设备上，不入库、不上报 ── */
  function readRecent() {
    try {
      var raw = window.localStorage.getItem(RECENT_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.slice(0, RECENT_MAX) : [];
    } catch (e) {
      /* 隐私模式下 localStorage 会直接抛错。搜索本身不该因此不能用。 */
      return [];
    }
  }

  function writeRecent(list) {
    try { window.localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX))); }
    catch (e) { /* 同上，写不进去就算了 */ }
  }

  function rememberQuery(q) {
    q = (q || '').trim();
    if (q.length < 2) return;
    var list = readRecent().filter(function (item) { return item.toLowerCase() !== q.toLowerCase(); });
    list.unshift(q);
    writeRecent(list);
  }

  function forgetQuery(q) {
    writeRecent(readRecent().filter(function (item) { return item !== q; }));
    paintRecent();
  }

  /* 最近搜过那一块是 Liquid 留的空壳，内容只有浏览器知道，所以在这里填。 */
  function paintRecent() {
    var host = el('[data-search-recent]', panel);
    if (!host) return;
    var list = readRecent();
    if (!list.length) { host.hidden = true; host.innerHTML = ''; return; }

    var s = strings();
    var clock = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" '
      + 'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
      + '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 1.8"/></svg>';
    var cross = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" '
      + 'stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';

    host.hidden = false;
    host.innerHTML = '<p class="eb-srch__h">' + escapeHtml(s.recent || 'Recent') + '</p>'
      + '<div class="eb-srch__list">'
      + list.map(function (term) {
        var safe = escapeHtml(term);
        return '<button class="eb-srch__row" type="button" data-search-term="' + safe + '" data-search-item>'
          + clock
          + '<span class="eb-srch__label">' + safe + '</span>'
          + '<span class="eb-srch__x" data-search-forget="' + safe + '" role="button" tabindex="0" '
          + 'aria-label="' + escapeHtml(s.forget || 'Remove') + '">' + cross + '</span>'
          + '</button>';
      }).join('')
      + '</div>';
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ── 取结果 ──────────────────────────────────────────────────
     section_id 让 Shopify 把这个 section 渲染好一起返回，
     省掉「先要 JSON、再自己拼 HTML」那一步。 */
  function fetchResults(q) {
    var overlay = el('[data-search]');
    if (!overlay) return;
    var limit = parseInt(overlay.dataset.resultsLimit, 10) || 6;

    if (controller) controller.abort();
    controller = ('AbortController' in window) ? new AbortController() : null;

    var url = root + 'search/suggest'
      + '?q=' + encodeURIComponent(q)
      + '&section_id=' + encodeURIComponent(OVERLAY_ID)
      + '&resources[type]=product,collection,page,query'
      + '&resources[limit]=' + limit
      + '&resources[options][unavailable_products]=last';

    panel.classList.add('is-busy');

    fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        /* 慢的那个请求后回来时，别把新的结果盖回旧的 */
        if (q !== currentQuery()) return;
        swap(html);
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        /* 网络断了不该让浮层卡在骨架上：退回空态，输入框里的字还在。 */
        showIdle();
      })
      .then(function () { panel.classList.remove('is-busy'); });
  }

  function currentQuery() { return input ? input.value.trim() : ''; }

  function swap(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nextBody = el('[data-search-body]', doc);
    var nextFoot = el('[data-search-foot]', doc);
    var body = el('[data-search-body]', panel);
    var foot = el('[data-search-foot]', panel);
    if (!nextBody || !body) return;

    body.innerHTML = nextBody.innerHTML;
    body.className = nextBody.className;
    if (nextFoot && foot) foot.innerHTML = nextFoot.innerHTML;

    cursor = -1;
    paintRecent();
  }

  /* 清空输入时不发请求 —— 空态那份 HTML 首屏就在，直接要回来即可 */
  function showIdle() {
    lastQuery = '';
    fetchIdle();
  }

  function fetchIdle() {
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(OVERLAY_ID);
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) { if (!currentQuery()) swap(html); })
      .catch(function () { /* 拿不到就维持现状，不清空 */ });
  }

  var onType = null;

  function handleInput() {
    var q = currentQuery();
    var clear = el('[data-search-clear]', panel);
    if (clear) clear.hidden = !q;

    if (q === lastQuery) return;
    lastQuery = q;

    if (!q) { if (controller) controller.abort(); showIdle(); return; }
    onType(q);
  }

  /* ── 键盘：上下键在左栏词条和右栏结果这一串里走 ── */
  function items() {
    return all('[data-search-item], .eb-srch__results .eb-pcard', panel)
      .filter(function (node) { return node.offsetParent !== null; });
  }

  function move(step) {
    var list = items();
    if (!list.length) return;
    if (list[cursor]) list[cursor].removeAttribute('aria-selected');
    cursor += step;
    if (cursor < 0) cursor = list.length - 1;
    if (cursor >= list.length) cursor = 0;
    var node = list[cursor];
    node.setAttribute('aria-selected', 'true');
    node.scrollIntoView({ block: 'nearest' });
  }

  function follow() {
    var list = items();
    var node = list[cursor];
    if (!node) return false;
    var link = node.matches('a[href]') ? node : el('a[href]', node);
    if (node.dataset && node.dataset.searchTerm) { applyTerm(node.dataset.searchTerm); return true; }
    if (link) { window.location.href = link.href; return true; }
    return false;
  }

  function applyTerm(term) {
    if (!input) return;
    input.value = term;
    input.focus();
    handleInput();
  }

  /* ── 开关 ── */
  function register() {
    if (!window.EB || !EB.overlay) return;
    EB.overlay.register(OVERLAY_ID, {
      onOpen: function () {
        var overlay = el('[data-search]');
        if (!overlay) return;
        panel = el('.eb-srch__panel', overlay);
        input = el('[data-search-input]', overlay);
        overlay.hidden = false;
        window.requestAnimationFrame(function () {
          overlay.classList.add('is-open');
          if (input) { input.focus(); input.select(); }
        });
        releaseFocus = EB.trapFocus(panel, input);
        paintRecent();
      },
      onClose: function () {
        var overlay = el('[data-search]');
        if (!overlay) return;
        overlay.classList.remove('is-open');
        if (releaseFocus) releaseFocus();
        cursor = -1;
        /* 等落下的动画反向走完再 hidden，否则它会瞬间消失而不是收上去 */
        window.setTimeout(function () {
          if (!overlay.classList.contains('is-open')) overlay.hidden = true;
        }, 420);
      }
    });
  }

  function open() { if (window.EB && EB.overlay) EB.overlay.open(OVERLAY_ID); }
  function close() { if (window.EB && EB.overlay) EB.overlay.close(OVERLAY_ID); }

  /* ── 事件 ── */
  function bind() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-eb-search-open]');
      if (opener) { e.preventDefault(); open(); return; }

      if (!panel) return;

      if (e.target.closest('[data-search-close]')) { e.preventDefault(); close(); return; }

      var forget = e.target.closest('[data-search-forget]');
      if (forget) { e.preventDefault(); e.stopPropagation(); forgetQuery(forget.dataset.searchForget); return; }

      var term = e.target.closest('[data-search-term]');
      if (term) { e.preventDefault(); applyTerm(term.dataset.searchTerm); return; }

      var clear = e.target.closest('[data-search-clear]');
      if (clear) {
        e.preventDefault();
        if (input) { input.value = ''; input.focus(); }
        handleInput();
        return;
      }

      /* 走出去之前把这次搜索记下来 */
      var hit = e.target.closest('.eb-srch__results a[href], .eb-srch__all');
      if (hit) rememberQuery(currentQuery());
    });

    document.addEventListener('input', function (e) {
      if (e.target.matches('[data-search-input]')) handleInput();
    });

    document.addEventListener('keydown', function (e) {
      var overlay = el('[data-search]');
      if (!panel || !overlay || !overlay.classList.contains('is-open')) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
      else if (e.key === 'Enter' && cursor > -1) {
        if (follow()) { rememberQuery(currentQuery()); e.preventDefault(); }
      }
    });

    /* 回车提交表单 = 去搜索结果页。记一笔再走。 */
    document.addEventListener('submit', function (e) {
      if (e.target.matches('[data-search-form]')) rememberQuery(currentQuery());
    });
  }

  /* 事件挂在 document 上，只挂一次 —— 编辑器里重载 section 会再进 init()，
     不拦住的话监听器会一份一份叠上去，一次点击触发三遍。 */
  var bound = false;

  function init() {
    var overlay = el('[data-search]');
    if (!overlay) return;
    panel = el('.eb-srch__panel', overlay);
    input = el('[data-search-input]', overlay);
    onType = (window.EB && EB.debounce) ? EB.debounce(fetchResults, DEBOUNCE) : fetchResults;
    register();
    if (!bound) { bind(); bound = true; }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* 主题编辑器里重新加载 section 后要重新登记 */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-search]')) init();
  });
})();
